<template>
  <div class="page">
    <div v-if="!editMode" class="float-right btn-group" >
      <router-link to="/fuel-consumptions" class="btn btn-primary">Назад</router-link>
      <button class="btn btn-primary" @click="editModeEnable" v-if="!editMode">Добавить</button>
    </div>
    <div v-else class="float-right btn-group">
      <button class="btn btn-primary" @click="addConsumption">Добавить</button>
      <button class="btn btn-danger" @click="editMode = false">Отменить</button>
    </div>
    <h3>Добавление расхода</h3>
    <div v-if="!editMode">
      <table class="table table-hover w-100 mt-3 d-none d-md-table">
        <TableSort :sorts="sorts" @sortsUpdate="loadWithSort" />
        <tbody>
          <tr v-if="getConsumptionsCar.length === 0">
            <td colspan="6" style="text-align: center">Ничего не найдено</td>
          </tr>
          <tr v-for="(consumptionItem, key) of getConsumptionsCar" :key="key">
            <td>
              <TextHighlight class="highlighter" :queries="searchText">{{ getFuelType(consumptionItem.fuel_type_id) ? getFuelType(consumptionItem.fuel_type_id).name : null }}</TextHighlight>
            </td>
            <td>
              <TextHighlight class="highlighter" :queries="searchText">{{ consumptionItem.date | formatDateTime }}</TextHighlight>
            </td>
            <td>
              <TextHighlight class="highlighter" :queries="searchText">{{ consumptionItem.author.first_name }} {{ consumptionItem.author.last_name }} {{ consumptionItem.author.middle_name }}</TextHighlight>
            </td>
            <td>
              <TextHighlight class="highlighter" :queries="searchText">{{ consumptionItem.consumption }}</TextHighlight>
            </td>
            <td>
              <TextHighlight class="highlighter" :queries="searchText">{{ consumptionItem.created_at | formatDateTime }}</TextHighlight>
            </td>
            <td>
              <TextHighlight class="highlighter" :queries="searchText">{{ consumptionItem.percentage_of_use }} %</TextHighlight>
            </td>
            <td>
              <font-awesome-icon
                icon="trash-alt"
                size="1x"
                :style="{
                  color: 'gray',
                  'margin-left': '1.5rem',
                  cursor: 'pointer'
                }"
                @click="removeConsumptionOld(consumptionItem.id)"
              />
              <router-link
                :to="'/fuel-consumptions/update/' + consumptionItem.id">
                <font-awesome-icon
                  icon="pen"
                  size="1x"
                  :style="{
                  color: 'gray',
                  'margin-left': '1.5rem',
                  cursor: 'pointer'
                }"/>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="mobile-table-view card mt-2 mb-2 p-2 d-md-none" v-for="(consumptionItem, key) of getConsumptionsCar" :key="key">
        <table v-if="getConsumptionsCar && getConsumptionsCar.length > 0"  class="table borderless">
          <tbody>
          <tr>
            <td style="border-top: none">Автомобиль</td>
            <td style="border-top: none">
              <TextHighlight class="highlighter" :queries="searchText">{{ consumptionItem.car.brand }} {{ consumptionItem.car.model }} - {{ consumptionItem.car.registration_plate }}</TextHighlight>
            </td>
          </tr>
          <tr>
            <td>Дата</td>
            <td>
              <TextHighlight class="highlighter" :queries="searchText">{{ consumptionItem.date | formatDateTime }}</TextHighlight>
            </td>
          </tr>
          <tr>
            <td>Тип топлива</td>
            <td>
              <TextHighlight class="highlighter" :queries="searchText">{{ getFuelType(consumptionItem.fuel_type_id) ? getFuelType(consumptionItem.fuel_type_id).name : null }}</TextHighlight>
            </td>
          </tr>
          <tr>
            <td>Расход на 100км</td>
            <td>
              <TextHighlight class="highlighter" :queries="searchText">{{ consumptionItem.consumption }}</TextHighlight>
            </td>
          </tr>
          <tr>
            <td>Автор</td>
            <td>
              <TextHighlight class="highlighter" :queries="searchText">{{ consumptionItem.author.first_name }} {{ consumptionItem.author.last_name }} {{ consumptionItem.author.middle_name }}</TextHighlight>
            </td>
          </tr>
          <tr>
            <td>Дата внесения записи</td>
            <td>
              <TextHighlight class="highlighter" :queries="searchText">{{ consumptionItem.created_at | formatDateTime }}</TextHighlight>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="d-flex">
          <button
            :to="{ name: 'carPage', params: { consumptionId: consumptionItem.id } }"
            class="btn btn-danger btn-md ml-auto"
            @click="removeConsumptionOld(consumptionItem.id)"
          >
            Удалить
          </button>
          <router-link
            class="btn btn-primary btn-md mx-2"
            :to="'/fuel-consumptions/update/' + consumptionItem.id">
            Редактировать
          </router-link>
        </div>
      </div>
    </div>
    <div v-if="editMode">
      <div class="row">
        <div class="col-12 col-lg-4">
          Дата начала
        </div>
        <div class="col-12 col-lg-4">
          <input type="datetime-local" class="form-control" v-model="dateStartConsumption" placeholder required />
        </div>
      </div>
      <table class="table w-100 mt-3 d-none d-md-table">
        <thead>
          <tr>
            <th>Топливо</th>
            <th>Расход на 100км</th>
            <th>Процент использования</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="consumptionsCarCopy.length === 0">
            <td colspan="4" style="text-align: center">Ничего не найдено</td>
          </tr>
          <tr v-for="(consumptionItem, key) of consumptionsCarCopy" :key="key">
            <td>
              <VSelect
                style="width: 100%"
                :options="fuelTypesCopy"
                v-model="consumptionItem.fuel_type_id"
                :reduce="option => option.id"
                label="name"
              >
                <template v-slot:option="option">{{ option.name }}</template>
              </VSelect>
            </td>
            <td>
              <input type="number" class="form-control" v-model="consumptionItem.consumption" placeholder required />
            </td>
            <td class="row w-100">
              <input class="for col p-0" style="max-width: 200px" type="range" min="0" max="100" step="1" v-model="consumptionItem.percentage_of_use">
              <input class="col-auto ml-2 p-0" style="width: 50px;" type="number" v-model="consumptionItem.percentage_of_use"/>
            </td>
            <td>
              <font-awesome-icon
                icon="trash-alt"
                size="1x"
                :style="{
                color: 'gray',
                'margin-left': '1.5rem',
                cursor: 'pointer'
              }"
                @click="deleteConsumption(key)"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div class="mobile-table-view card mt-2 mb-2 p-2 d-md-none" v-for="(consumptionItem, key) of consumptionsCarCopy" :key="key">
        <table v-if="consumptionsCarCopy && consumptionsCarCopy.length > 0"  class="table borderless">
          <tbody>
            <tr>
              <td>Топливо</td>
              <td>
                <VSelect
                  style="width: 100%"
                  :options="fuelTypesCopy"
                  v-model="consumptionItem.fuel_type_id"
                  :reduce="option => option.id"
                  label="name"
                >
                  <template v-slot:option="option">{{ option.name }}</template>
                </VSelect>
              </td>
            </tr>
            <tr>
              <td>Расход на 100км</td>
              <td>
                <input type="number" class="form-control" v-model="consumptionItem.consumption" placeholder required />
              </td>
            </tr>
            <tr>
              <td>Процент использования</td>
              <td>
                <input class="for col p-0" style="max-width: 200px" type="range" min="0" max="100" step="1" v-model="consumptionItem.percentage_of_use">
                <input class="col-auto ml-2 p-0" style="width: 50px;" type="number" v-model="consumptionItem.percentage_of_use"/>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex">
          <button
            v-if="consumptionItem.date_end"
            :to="{ name: 'carPage', params: { consumptionId: consumptionItem.id } }"
            class="btn btn-danger btn-md ml-auto"
            @click="deleteConsumption(consumptionItem.id)"
          >
            Удалить
          </button>
        </div>
      </div>
    </div>
    <button class="btn btn-success" v-if="editMode" @click="saveConsumption">Сохранить</button>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import Swal from 'sweetalert2'
import { mapState, mapActions } from 'vuex'
import userApi from '@/api/user'
import FuelConsumptionsApi from '../../api/fuelConsumptions'

export default {
  name: 'ConsumptionCar',
  props: ['id'],
  data () {
    return {
      editMode: false,
      consumptionsCarCopy: [],
      sorts: [
        {
          name: 'Тип топлива',
          storeName: 'fuelTypeIdIndex',
          values: ['', 'fuel_type_id', '-fuel_type_id'],
          order: 2
        }, {
          name: 'Дата',
          storeName: 'dateIndex',
          values: ['', 'date', '-date'],
          order: 0
        }, {
          name: 'Автор',
          storeName: 'authorIdIndex',
          values: ['', 'author_id', '-author_id'],
          order: 1,
          disabled: true
        }, {
          name: 'Расход на 100км',
          storeName: 'consumptionIndex',
          values: ['', 'consumption', '-consumption'],
          order: 3
        }, {
          name: 'Дата внесения записи',
          storeName: 'createdAtIndex',
          values: ['', 'created_at', '-created_at'],
          order: 4
        }, {
          name: 'Процент использования',
          storeName: 'percentageOfUseIndex',
          values: ['', 'percentage_of_use', '-percentage_of_use'],
          order: 5,
          disabled: true
        }, {
          name: ' ',
          storeName: 'percentageOfUseIndex',
          values: ['', 'percentage_of_use', '-percentage_of_use'],
          order: 6,
          disabled: true
        }
      ],
      user: null,
      fuelTypesCopy: null,
      date: null
    }
  },
  computed: {
    ...mapState('fuel/fuelConsumption', {
      consumptionList: state => state.items,
      searchText: state => state.searchText,
      pageCount: state => state.pageCount,
      isLoading: state => state.isLoading
    }),
    ...mapState('taxi/cars', {
      cars: state => state.items
    }),
    ...mapState('fuel/fuelType', {
      fuelTypes: state => state.items.filter(e => !e.archived_at)
    }),
    getFuelType () {
      return (fuelTypeId) => {
        if (!this.fuelTypesCopy) {
          return null
        }
        return this.fuelTypesCopy.find(fuelType => fuelType.id === fuelTypeId)
      }
    },
    dateStartConsumption: {
      get () {
        return dayjs(this.date).format('YYYY-MM-DDTHH:mm')
      },
      set (dateTime) {
        this.date = dayjs(dateTime, 'YYYY-MM-DDTHH:mm').format('YYYY-MM-DDTHH:mm:ssZZ')
      }
    },
    getConsumptionsCar () {
      return this.consumptionList.filter(e => e.car.id == this.id)
    }
  },
  beforeMount () {
    this.loadCars()
    this.loadFuels().then(fuels => {
      this.fuelTypesCopy = JSON.parse(JSON.stringify(fuels))
    })
    userApi.getCurrentUser()
      .then(user => {
        this.user = user
      })
      .catch(err => {
        console.error(err)
        this.isCreating = false
        Swal.fire({
          icon: 'error',
          title: 'Ошибка',
          html: err.message
        })
      })
  },
  mounted () {
    this.setTitle({
      items: [
        {
          title: 'Расход',
          url: '/fuel-consumptions'
        },
        {
          title: 'Изменить'
        }
      ]
    })
  },
  methods: {
    ...mapActions('taxi/cars', {
      loadCars: 'loadItems'
    }),
    ...mapActions('fuel/fuelType', {
      loadFuels: 'loadItems'
    }),
    ...mapActions('fuel/fuelConsumption', { loadConsumption: 'loadItems', setSorts: 'setSorts' }),
    ...mapActions('taxi', [
      'setTitle'
    ]),
    loadWithSort (sorts) {
      this.setSorts(sorts)
      this.loadConsumption()
    },
    editModeEnable () {
      this.editMode = true
      this.date = this.getConsumptionsCar.length ? this.getConsumptionsCar[0].date : null
      const usedFuelType = []
      this.consumptionsCarCopy = JSON.parse(JSON.stringify(
        this.getConsumptionsCar
          .filter(consumption => {
            if (!consumption.date_end && !usedFuelType.includes(consumption?.fuel_type_id)) {
              usedFuelType.push(consumption.fuel_type_id)
              return true
            }
            return false
          })
      ))
    },
    addConsumption () {
      this.consumptionsCarCopy.push({
        fuel_type_id: 0,
        consumption: 0,
        date: 0,
        percentage_of_use: 0,
        create_at: 0
      })
    },
    saveConsumption () {
      const usedFuelTypes = []
      let incorrectDataEntered = false
      this.consumptionsCarCopy.forEach(consumption => {
        if (usedFuelTypes.includes(consumption.fuel_type_id)) {
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: 'Присутствуют повторяющиеся виды топлива'
          })
          incorrectDataEntered = true
          return false
        }
        usedFuelTypes.push(consumption.fuel_type_id)
      })
      if (!incorrectDataEntered) {
        const allPercentage = this.consumptionsCarCopy.reduce(function (prev, consumption) {
          return prev + Number(consumption.percentage_of_use)
        }, 0)
        if (allPercentage === 100) {
          this.consumptionsCarCopy.forEach(consumption => {
            consumption.date = this.date
            consumption.author_id = this.user.id
            consumption.car_id = this.id
            FuelConsumptionsApi.createItem(consumption)
              .catch(err => {
                console.error(err)
                Swal.fire({
                  icon: 'error',
                  title: 'Ошибка',
                  html: err.message
                })
              })
            this.editMode = false
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: 'Общее число процентов не равно 100'
          })
        }
      }
    },
    deleteConsumption (key) {
      this.$delete(this.consumptionsCarCopy, key)
    },
    removeConsumptionOld (id) {
      FuelConsumptionsApi.removeItem(id)
      this.loadConsumption()
    }
  }
}
</script>
